import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { fetchDataList } from "../../api";
import parseHTML from "../../helpers/parseHTML";
import { GlobalContext } from "../../context/GlobalContext";

function ToolDisclaimer() {
  const { isMobile } = React.useContext(GlobalContext);
  const { data: data } = useQuery(["general-disclaimer"], () =>
    fetchDataList("general")
  );

  return (
    <div
      className={`text-muted footer bg-dark tooldisclaimer ${
        isMobile && "text-left"
      }`}
    >
      {data?.tooldisclaimer}
    </div>
  );
}

export default ToolDisclaimer;
